// extracted by mini-css-extract-plugin
module.exports = {"search-container":"Search_search-container__bEhNi","search-title":"Search_search-title__PgLPj","search__loader":"Search_search__loader__3VtpD"};